import { Box, styled } from '@auth0/quantum-product';
export var FeedbackSectionContainer = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'relative',
        gap: theme.spacing(1.5),
        marginTop: theme.spacing(2),
    });
});
